import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit Express PRO: Encuadre en 10 Min',
  desc: '6 plantillas copy/paste de admisión con protocolo, legajo y cierre de primera sesión.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Scripts PRO de Comunicación Clínica',
  desc: '80 mensajes y frases listos para honorarios, cancelaciones, derivaciones y seguimiento.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Evolución & Registros Clínicos 360',
  desc: 'Trackers de proceso + informe de avance + informe de alta + notas de sesión.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Intervenciones SOS de Consultorio',
  desc: '24 intervenciones listas con objetivo, desarrollo y cierre. Para sesiones sin dirección.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Consultorio 360: Setup Profesional',
  desc: 'Organización operativa + checklists de apertura y cierre + rutina semanal del profesional.',
  price: '$8.000'
}, {
  num: '06',
  title: 'Situaciones Difíciles en Sesión',
  desc: '25 casos clínicos reales resueltos: qué hacer, qué decir y cómo sostener el encuadre.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(254,242,242) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-47">
      <div className="mx-auto max-w-3xl" data-id="element-48">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-49">
          Más los <span className="text-violet-700" data-id="element-50">6 Bonos Estratégicos</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-51">
          Incluidos en todas las ofertas — sin costo extra
        </p>

        {/* Bonus List */}
        <div className="bg-white border border-violet-500/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-52">
          {/* Header */}
          <div className="bg-violet-700 px-5 py-3" data-id="element-53">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-54">
              🎁 LOS 6 BONOS — Incluidos siempre
            </h3>
          </div>

          {/* List */}
          <div className="divide-y divide-gray-100" data-id="element-55">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-3" data-id="element-56">
                {/* Número */}
                <span className="shrink-0 text-lg font-black text-violet-700/30 w-8 text-center" data-id="element-57">
                  {bonus.num}
                </span>

                {/* Contenido */}
                <div className="flex-1 min-w-0" data-id="element-58">
                  <span className="block text-sm font-black text-gray-900" data-id="element-59">
                    {bonus.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-60">
                    {bonus.desc}
                  </span>
                </div>

                {/* Precio tachado + GRATIS */}
                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-61">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-62">
                    {bonus.price}
                  </span>
                  <span className="text-[10px] font-black text-white bg-violet-700 rounded-full px-2 py-0.5" data-id="element-63">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Total Value Footer */}
        <div className="text-center rounded-xl px-5 py-4 shadow-sm" style={{
        backgroundColor: 'rgb(245, 243, 255)',
        border: '1px solid rgba(124, 58, 237, 0.3)'
      }} data-id="element-64">
          <p className="text-xs font-bold uppercase tracking-widest text-violet-700 m-0 mb-1" data-id="element-65">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3" data-id="element-66">
            <span className="text-base text-gray-400 line-through" data-id="element-67">
              $58.000
            </span>
            <span className="text-lg font-black text-violet-700" data-id="element-68">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>
      </div>
    </section>;
}